import InfantilFiesta from "./InfantilFiesta";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "infantil-fiesta",
  tipoEvento: "infantil",
  tipoEtiqueta: "Cumpleaños infantil",
  nombre: "Fiesta de Colores",
  descripcion:
    "Diseño alegre y lúdico con nombre y edad protagonistas, ilustraciones originales (banderines, globos y confeti) y estilo de stickers. Sin personajes comerciales.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    confeti: "/miniaturas/infantil-fiesta-confeti.jpg",
    frutilla: "/miniaturas/infantil-fiesta-frutilla.jpg",
    oceano: "/miniaturas/infantil-fiesta-oceano.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: InfantilFiesta,
};
